import { render, staticRenderFns } from "./EmergingArtistCard.vue?vue&type=template&id=2f77d8df&scoped=true&"
import script from "./EmergingArtistCard.vue?vue&type=script&lang=js&"
export * from "./EmergingArtistCard.vue?vue&type=script&lang=js&"
import style0 from "./EmergingArtistCard.vue?vue&type=style&index=0&id=2f77d8df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f77d8df",
  null
  
)

export default component.exports